module.exports = __webpack_public_path__ + "static/media/SOLUS045_GA_PlanView.8c311701.svg";